//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { MediaTrackingEventName } from '@tracker/mediaTracking/mediaTrackingModel';

(function () {
  const uia = angular.module('uia');
  const ESCAPE_KEY_CODE = 27;

  uia.directive('universalImageActionsProductize', [
    '$q',
    '$rootScope',
    'AccountSettingsService',
    'AssistedProductTaggingService',
    'PRODUCT_RESULTS_TYPES',
    'ProductSearchService',
    'ProductTaggingService',
    'ShowroomService',
    'UniversalImageActionsService',
    function (
      $q,
      $rootScope,
      AccountSettingsService,
      AssistedProductTaggingService,
      PRODUCT_RESULTS_TYPES,
      ProductSearchService,
      ProductTaggingService,
      ShowroomService,
      UniversalImageActionsService,
    ) {
      return {
        restrict: 'E',
        scope: {
          features: '=',
        },
        require: '^universalImageActionsModal',
        template: require('@legacy-components/common/universal-image-actions/universal-image-actions-productize.html'),
        controller: [
          '$scope',
          '$timeout',
          'ErrorNotificationService',
          'TrackingService',
          'UniversalImageActionsHelpers',
          'UniversalImageActionsItemType',
          'SessionVarsService',
          'UniversalImageActionWorkflows',
          function (
            $scope,
            $timeout,
            ErrorNotificationService,
            TrackingService,
            UniversalImageActionsHelpers,
            UniversalImageActionsItemType,
            SessionVarsService,
            UniversalImageActionWorkflows,
          ) {
            const launchOptions =
              UniversalImageActionsService.getCurrentLaunchOptions();
            const currentPage = UniversalImageActionsService.getCurrentPage();
            const TRACKING_CATEGORY =
              UniversalImageActionsHelpers.getTrackingCategory(currentPage);
            let feedbackGiven;

            $scope.model = {
              products: [],
              outstandingSaveRequest: null,
              addingProductBySpatialTag: false,
              addingProduct: false,
              editor: {
                enabled: false,
                productIndex: null,
                editingNewProduct: false,
                currentProduct: null,
              },
              productsGrid: {
                enabled: false,
                showSuggestions: false,
              },
              searchBar: {
                advertiser: null,
                catalogClient: null,
                catalogSelectorLoading:
                  SessionVarsService.isFeatureEnabled('syndication') &&
                  launchOptions.getItemType() ===
                    UniversalImageActionsItemType.syndication,
              },
              isIntelligentProductTaggingEnabled:
                SessionVarsService.isFeatureEnabled(
                  FeatureNames.UiaIntelligentProductTagging,
                ),
              showCatalogSelector:
                SessionVarsService.isFeatureEnabled('syndication') &&
                launchOptions.getItemType() ===
                  UniversalImageActionsItemType.syndication,
              trackingCategory: TRACKING_CATEGORY,
              loading: true,
              disableAddingProducts: false,
              universalItemId: launchOptions.getUniversalItemId(),
              currentlyInWorkflow:
                !!UniversalImageActionsService.getCurrentWorkflow(),
              isOnePageWorkflow:
                !!UniversalImageActionsService.getCurrentWorkflow() &&
                UniversalImageActionsService.getCurrentWorkflow().name ===
                  UniversalImageActionWorkflows.CreateOnePage,
              isTributaryWorkflow:
                !!UniversalImageActionsService.getCurrentWorkflow() &&
                UniversalImageActionsService.getCurrentWorkflow().name ===
                  UniversalImageActionWorkflows.CreateAdaptiveLink,
              isShowroomSelfServeV2Enabled: SessionVarsService.isFeatureEnabled(
                FeatureNames.ShowroomSelfServeV2,
              ),
              isShareV2VendorClient: SessionVarsService.isShareV2VendorClient(),
              isVisualSyndicationEnabled: SessionVarsService.isFeatureEnabled(
                FeatureNames.BazaarvoiceNetworkSyndicationFrontend,
              ),
              isUIAReactPortItemProductsEnabled:
                SessionVarsService.isFeatureEnabled(
                  // TODO: PD-261863 - Remove feature flag usage once UIA port is completed
                  FeatureNames.UiaReactPortItemProducts,
                ),
            };

            const callOverlayMethodWithValueFunc = function (broadcastEvent) {
              return function (newVal, oldVal) {
                // Sometimes Angular goofs and fires the watcher callback on declaration of a variable and newVal === oldVal
                if (
                  angular.isDefined(newVal) &&
                  !angular.equals(newVal, oldVal)
                ) {
                  $timeout(() => {
                    $rootScope.$broadcast(
                      `uia:products:${broadcastEvent}`,
                      newVal,
                    );
                  }, 0);
                }
              };
            };

            // These watchers keep the overlay in sync with the editor
            $scope.$watch(
              'model.editor',
              callOverlayMethodWithValueFunc('setEditorState'),
              true,
            );
            $scope.$watch(
              'model.addingProduct',
              callOverlayMethodWithValueFunc('setAddingProduct'),
            );

            function linkProductToBoundingBox(
              productStyleId,
              productName,
              productsList,
            ) {
              // Find the product with the same style ID if it exists; if not, fall back to finding a product with a matching name
              const newProductToLink =
                _(productsList).findWhere({ productStyleId }) ||
                _(productsList).findWhere({ name: productName });

              if (newProductToLink && newProductToLink.productStyleId) {
                AssistedProductTaggingService.linkProductToBoundingBoxAsync(
                  $scope.model.universalItemId,
                  $scope.model.boxId,
                  newProductToLink.productStyleId,
                );
              }
            }

            function updateBoundingBoxForProduct(
              oldProductStyleId,
              oldProductName,
              productsList,
            ) {
              const existingBoundingBox =
                AssistedProductTaggingService.getBoundingBoxByProductStyleId(
                  $scope.model.universalItemId,
                  oldProductStyleId,
                );
              if (existingBoundingBox) {
                const isProductSameStyleId = _(productsList).some((product) => {
                  return (
                    product.productStyleId &&
                    product.productStyleId === oldProductStyleId
                  );
                });

                if (!isProductSameStyleId) {
                  const newProduct = _(productsList).findWhere({
                    name: oldProductName,
                  });
                  if (newProduct && newProduct.productStyleId) {
                    AssistedProductTaggingService.linkProductToBoundingBoxAsync(
                      $scope.model.universalItemId,
                      existingBoundingBox.boxId,
                      newProduct.productStyleId,
                    );
                  }
                }
              }
            }

            function handleSaveSuccess() {
              $scope.model.disableAddingProducts = false;
              $scope.model.numProductsWithMissingInfo = 0;
              $rootScope.$broadcast('uia:products:enable-add-product');
              if ($scope.model.isTributaryWorkflow) {
                ShowroomService.invalidateShowroomCache();
              }
            }

            function handleSaveError(error) {
              const defaultMessage =
                "We couldn't save your changes. Please try again.";

              if (error && error.validationError) {
                $scope.model.products = angular.copy(error.products);

                if (error.errorMessage) {
                  $scope.model.disableAddingProducts = true;
                  $scope.$broadcast(
                    'uia:products:displayError',
                    error.errorMessage,
                  );
                  $rootScope.$broadcast('uia:products:disable-add-product');
                  $scope.model.numProductsWithMissingInfo = 1;
                }

                return;
              }

              $scope.model.disableAddingProducts = false;
              $scope.model.numProductsWithMissingInfo = 0;
              $rootScope.$broadcast('uia:products:enable-add-product');

              let errorMessage = (error && error.message) || defaultMessage;

              const errorId = _(error).safeGet('errorId');
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                TrackingService.ACTION_ERROR,
                errorId,
              );

              const errorCode = error && error.errorCode;
              if (_.isEmpty(errorCode)) {
                if (error.message) {
                  ErrorNotificationService.showDefaultErrorDialog(
                    error.message,
                    error,
                  );
                } else {
                  ErrorNotificationService.showDefaultErrorDialog(error);
                }
              } else {
                errorMessage = `Error ${error.errorCode}: ${errorMessage}`;
                $scope.$broadcast('uia:products:displayError', errorMessage); // Notify products section that an error occurred
              }
            }

            function beginAddProductFlow(
              fromSpatialTag,
              offsetX,
              offsetY,
              boxId,
            ) {
              if (
                $scope.model.disableProductTagging ||
                $scope.model.disableAddingProducts
              ) {
                $scope.model.addingProduct = false;
                return;
              }

              $scope.model.addingProductBySpatialTag = fromSpatialTag;
              if ($scope.model.addingProductBySpatialTag) {
                const tag = {
                  offsets: { offsetX, offsetY },
                  isNewTag: true,
                };
                $rootScope.$broadcast(
                  'uia:products:setSpatialTagPosition',
                  tag,
                );
              }

              $scope.model.boxId = boxId;
              feedbackGiven = false;

              $scope.model.addingProduct = true;
              $scope.model.productsGrid.enabled = true;
            }

            $scope.model.resetAddEditFlow = () => {
              $scope.model.addingProductBySpatialTag = false;
              $scope.model.addingProduct = false;
              $scope.model.editor = {
                enabled: false,
                productIndex: null,
                editingNewProduct: false,
              };
              $scope.model.productsGrid = {
                enabled: false,
                showSuggestions: false,
              };
              $rootScope.$broadcast('uia:products:setEditorSpatialTag', null);
            };

            const addProduct = (newProduct) => {
              let tagLocation;

              if (newProduct.spatialTag) {
                if ($scope.model.addingProductBySpatialTag) {
                  tagLocation = 'spatial';
                } else {
                  tagLocation = 'search';
                }
              } else {
                tagLocation = 'none';
              }

              const productAlreadyAdded =
                newProduct &&
                newProduct.productStyleId &&
                _($scope.model.products).findWhere({
                  productStyleId: newProduct.productStyleId,
                });

              if (productAlreadyAdded) {
                ErrorNotificationService.showDefaultErrorDialog(
                  'This product is already tagged in this image.',
                );
                return;
              }

              $scope.model.outstandingSaveRequest = 'add-product';
              $scope.model.resetAddEditFlow();

              ProductTaggingService.addProductAsync(newProduct)
                .then((productsList) => {
                  let action;
                  const label = `item=${launchOptions.getUniversalItemId()}`;

                  if (tagLocation === 'spatial') {
                    action = TrackingService.ACTION_ADD_PRODUCT_SPATIAL;
                  } else if (tagLocation === 'search') {
                    action = TrackingService.ACTION_ADD_PRODUCT_SEARCH;
                  } else {
                    action = TrackingService.ACTION_ADD_PRODUCT;
                  }

                  TrackingService.recordEvent(TRACKING_CATEGORY, action, label);

                  if (
                    $scope.model.isIntelligentProductTaggingEnabled &&
                    $scope.model.boxId
                  ) {
                    linkProductToBoundingBox(
                      newProduct.productStyleId,
                      newProduct.name,
                      productsList,
                    );
                  }
                  handleSaveSuccess();
                })
                .catch((error) => {
                  handleSaveError(error);
                })
                .finally(() => {
                  $scope.model.outstandingSaveRequest = null;
                });
            };

            const updateProduct = (updatedProduct) => {
              const updatedProductIndex = $scope.model.editor.productIndex;

              $scope.model.outstandingSaveRequest = 'update-product';
              $scope.model.resetAddEditFlow();

              ProductTaggingService.updateProductAsync(
                updatedProduct,
                updatedProductIndex,
              )
                .then((productsList) => {
                  if ($scope.model.isIntelligentProductTaggingEnabled) {
                    updateBoundingBoxForProduct(
                      updatedProduct.productStyleId,
                      updatedProduct.name,
                      productsList,
                    );
                  }
                  handleSaveSuccess();
                })
                .catch((error) => {
                  handleSaveError(error);
                })
                .finally(() => {
                  $scope.model.outstandingSaveRequest = null;
                });
            };

            $scope.$on(
              'uia:products:updateSpatialTag',
              ($event, productIndex, spatialTag) => {
                $scope.model.editor.productIndex = productIndex;
                const editedProduct =
                  $scope.model.products[$scope.model.editor.productIndex];
                editedProduct.spatialTag = spatialTag;
                updateProduct(editedProduct);
              },
            );

            $scope.model.editNewProductCallback = (product) => {
              if (product) {
                $scope.model.productsGrid.enabled = false;
                $scope.model.editor.editingNewProduct = true;
                $scope.model.editor.currentProduct = product;
                $scope.model.editor.enabled = true;
              }
            };

            $scope.model.productSearchCallback = () => {
              $scope.model.editor.enabled = false;
              $scope.model.productsGrid.enabled = true;
            };

            $scope.model.cancelEditingCallback = () => {
              $rootScope.$broadcast('uia:products:cancelProductEditing');
              const addEdit = $scope.model.addingProduct ? 'ADD' : 'EDIT';
              TrackingService.recordEvent(
                TRACKING_CATEGORY,
                TrackingService.ACTION_CANCEL_PRODUCT_EDIT,
                addEdit,
              );
              $scope.model.resetAddEditFlow();
            };

            $scope.model.close = function () {
              $scope.$emit('uia:modal:close');
            };

            $scope.model.orderChangedCallback = (newProducts) => {
              $scope.model.outstandingSaveRequest = 'sort-products';

              ProductTaggingService.updateProductsAsync(newProducts)
                .then(() => {
                  handleSaveSuccess();
                })
                .catch((error) => {
                  handleSaveError(error);
                })
                .finally(() => {
                  $scope.model.outstandingSaveRequest = null;
                });
            };

            $scope.model.updateProductCallback = (updatedProduct) => {
              const isNewProduct = false;
              $rootScope.$broadcast(
                'uia:products:addSpatialTagInfo',
                updatedProduct,
                isNewProduct,
              );
            };

            $scope.model.addProductCallback = (newProduct) => {
              UniversalImageActionsService.trackMediaEvent(
                MediaTrackingEventName.ProductAdded,
              );
              if ($scope.model.addingProductBySpatialTag) {
                const isNewProduct = true;
                $rootScope.$broadcast(
                  'uia:products:addSpatialTagInfo',
                  newProduct,
                  isNewProduct,
                );
              } else {
                addProduct(newProduct);
              }
            };

            $scope.model.removeProductCallback = (
              productIndex,
              productStyleId,
            ) => {
              $scope.model.outstandingSaveRequest = 'remove-product';

              ProductTaggingService.removeProductAsync(productIndex)
                .then(() => {
                  TrackingService.recordEvent(
                    TRACKING_CATEGORY,
                    TrackingService.ACTION_REMOVE_PRODUCT,
                  );
                  const existingBoundingBox =
                    AssistedProductTaggingService.getBoundingBoxByProductStyleId(
                      $scope.model.universalItemId,
                      productStyleId,
                    );

                  if (existingBoundingBox) {
                    const productCategory = _(
                      existingBoundingBox.keywords,
                    ).first();
                    TrackingService.recordEvent(
                      TRACKING_CATEGORY,
                      TrackingService.ACTION_DELETE_PRODUCT_BOUNDING_BOX,
                      productCategory,
                    );
                  }

                  handleSaveSuccess();
                })
                .catch((error) => {
                  handleSaveError(error);
                })
                .finally(() => {
                  $scope.model.outstandingSaveRequest = null;
                });
            };

            $scope.model.editProductCallback = (
              productIndex,
              dontOpenEditPanel,
            ) => {
              const editedProduct = $scope.model.products[productIndex];
              if (editedProduct.spatialTag && editedProduct.position) {
                $rootScope.$broadcast(
                  'uia:products:setEditorSpatialTag',
                  editedProduct.spatialTag,
                );
              }
              $scope.model.editor.productIndex = productIndex;
              $scope.model.editor.currentProduct = editedProduct;
              if (!dontOpenEditPanel) {
                $scope.model.editor.enabled = true;
              }
            };

            $scope.$on(
              'uia:edit-product-from-overlay',
              ($event, index, dontOpenEditPanel) => {
                $scope.model.editProductCallback(index, dontOpenEditPanel);
              },
            );

            $scope.model.advertiserSelectedCallback = (newAdvertiser) => {
              $scope.model.searchBar.advertiser = newAdvertiser;
            };

            $scope.model.catalogSelectedCallback = (catalogClient) => {
              $scope.model.searchBar.catalogClient = catalogClient;
            };

            $scope.model.catalogSelectorLoadedCallback = () => {
              $scope.model.searchBar.catalogSelectorLoading = false;
            };

            $scope.$on('uia:products-changed', ($event, products) => {
              $scope.model.products = angular.copy(products);
              UniversalImageActionsService.setNumTaggedProducts(
                $scope.model.products.length,
              );
            });

            // when new spatial tag is canceled in overlay
            $scope.$on('uia:products:cancelNewSpatialTag', () => {
              $scope.model.resetAddEditFlow();
            });

            // when new spatial tag is created in overlay
            $scope.$on(
              'uia:products:begin-add-product-flow',
              ($event, params) => {
                beginAddProductFlow(
                  true,
                  params.offsetX,
                  params.offsetY,
                  params.boxId,
                );
              },
            );

            $scope.$on('uia:products:removeSpatialTag', () => {
              $scope.model.addingProductBySpatialTag = false;
            });

            $scope.$on(
              'uia:products:spatialTagInfoAdded',
              ($event, productWithSpatialTag, isNewProduct) => {
                if (isNewProduct) {
                  addProduct(productWithSpatialTag);
                } else {
                  updateProduct(productWithSpatialTag);
                }
              },
            );

            $scope.model.close = () => {
              // TODO: Revisit the UX here in case it's confusing that the modal doesn't close when pressing this button.
              // TODO: See DEV-9437 for additional context on this check.
              if (!$scope.model.outstandingSaveRequest) {
                $scope.$emit('uia:modal:close', {
                  result: {
                    actionCompleted: TrackingService.ACTION_PRODUCTIZE,
                  },
                });
              }
            };

            $scope.model.addProductWithoutTag = () => {
              beginAddProductFlow(false);
            };

            $scope.model.isDisabled = () => {
              return $scope.isParentDisabled || $scope.model.editor.enabled;
            };

            $scope.model.isScrolled = () => {
              return (
                !feedbackGiven &&
                angular.element('.productize-content-wrapper').scrollTop() > 100
              );
            };

            $scope.model.updateFeedbackGiven = (feedbackGivenStatus) => {
              feedbackGiven = feedbackGivenStatus;
            };

            AccountSettingsService.getProductCatalogs()
              .then((catalogs) => {
                $scope.model.isCatalogConnected = !!(
                  catalogs && catalogs.length
                );
              })
              .catch(() => {
                $scope.model.isCatalogConnected = false;
              });

            ProductSearchService.getProductsState().subscribe(
              (productsState) => {
                if (
                  productsState.resultsType ===
                  PRODUCT_RESULTS_TYPES.CATALOG_SUGGESTIONS
                ) {
                  $scope.model.productsGrid.showSuggestions = true;
                } else {
                  $scope.model.productsGrid.showSuggestions = false;
                }
              },
            );

            function initializeMetadata() {
              UniversalImageActionsService.getItemMetadataAsync().then(
                (metadata) => {
                  $scope.model.isBvCampaignTagged = metadata.isBvCampaignTagged;
                },
              );
            }

            initializeMetadata();
          },
        ],
        link(scope, element, attrs, universalImageActionsModal) {
          const modalElem = angular.element(element.closest('.modal'));
          const launchOptions =
            UniversalImageActionsService.getCurrentLaunchOptions();

          scope.model.currentlyInWorkflow =
            universalImageActionsModal.currentlyInWorkflow();

          const setInitialEditorialState = function () {
            // Enter the edit flow if we launched UIA with some products already selected
            const launchProducts = launchOptions.getLaunchProducts() || [];

            if (launchProducts.length > 0) {
              scope.model.editor.enabled = true;
              scope.model.editor.editingNewProduct = true;
            }
          };

          if (scope.model.isTributaryWorkflow) {
            if (scope.model.isShowroomSelfServeV2Enabled) {
              ShowroomService.loadExistingState(scope.model.universalItemId);
            } else {
              ShowroomService.reloadState(scope.model.universalItemId);
            }
          }

          $q.all([UniversalImageActionsService.getItemMetadataAsync()]).then(
            (responses) => {
              const metadata = responses[0];

              scope.model.products = angular.copy(
                ProductTaggingService.getProducts(),
              );
              UniversalImageActionsService.setNumTaggedProducts(
                scope.model.products.length,
              );
              setInitialEditorialState();
              scope.model.loading = false;
              scope.model.disableProductTagging =
                metadata.disableProductTagging;
              scope.model.reelId = metadata.reelId;
            },
          );

          element.find('.productize-content-wrapper').on('scroll', () => {
            scope.$applyAsync();
          });

          scope.features = scope.features || {};
          // Set some default features if none are passed
          scope.features.withSpatialTagging =
            scope.features.withSpatialTagging || true;
          scope.features.disableProductEditing =
            scope.features.disableProductEditing || false;

          // Disable ESC button modal close if there is an oustanding save
          modalElem.on('keydown.product-keydown', (event) => {
            if (
              event.which === ESCAPE_KEY_CODE &&
              scope.model.outstandingSaveRequest
            ) {
              event.stopPropagation();
              event.preventDefault();
            }
          });

          // Remove the keydown listener after the productize panel scope is destroyed
          scope.$on('$destroy', () => {
            modalElem.off('keydown.product-keydown');
          });
        },
      };
    },
  ]);
})();
